import {
  PhoneCallAtsCandidateDocument,
  PhoneCallAtsCandidateMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const usePhoneCallAtsCandidate = () => {
  const [phoneCallAtsCandidate, { loading }] = useMutation(PhoneCallAtsCandidateDocument, {
    extractorFn: (data) => data.atsMutations.phoneCallAtsCandidate,
  })

  return {
    loading,
    phoneCallAtsCandidate(variables: PhoneCallAtsCandidateMutationVariables) {
      return phoneCallAtsCandidate({ variables })
    },
  }
}
